<template>
    <div class="reward-tab">
        <div class="tab-hd">
            <div class="u-btn" v-for="(item,index) in config.tab_hd"
            :key="index"
            :class="[{act : index == now},'t-' + (index + 1)]"
            @click="now=index"></div>
        </div>

        <div class="tab-view">
            <div class="tab-img" v-for="(item,index) in config.tab_bd" :key="index" v-show="index == now">
                <el-image :key="item.img" :src="item.img">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>                    
                </el-image>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .tab-hd{
        display: flex;
        justify-content: space-between;
        padding: 0 45px;
    }

    .tab-hd .u-btn{
        width: 403px;
        height: 63px;
        background-position: center;
        background-repeat: no-repeat;
    }

    .u-btn.t-1{
        background-image: url(../assets/images/tab-r-1.png);
    }

    .u-btn.t-1.act{
        background-image: url(../assets/images/tab-r-1-act.png);
    }    

    .u-btn.t-2{
        background-image: url(../assets/images/tab-r-2.png);
    }
    
    .u-btn.t-2.act{
        background-image: url(../assets/images/tab-r-2-act.png);
    }
    
    .tab-view{
        width: 1194px;
        height: 1065px;
        margin: 20px auto 0;
        background-image: url(../assets/images/bg-tab.png);
    }

    .tab-img{
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
    }

</style>

<script>
export default {
    data (){
        return {
            config : {
                tab_hd : ['正赛奖励','娱乐赛奖励'],
                tab_bd : [{
                    img : require("../assets/images/tab-img-1.png"),
                },{
                    img : require("../assets/images/tab-img-2.png"),
                }]
            },
            now : 0,
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/rewardTab.vue